import { ohrAxiosProtected as axios } from '../httpInstance/http'

export const getAvatars = (users = '') => {
    return axios.get(`/oh_avatars/user/avatar/bulk/?user=${users}`)
}

export const getAvatarsLastModified = (users = '') => {
    return axios.get(`/oh_avatars/user/avatar/timestamp/?user=${users}`)
}
